export const USER_UPDATE = 'USER_UPDATE';
export const TOKENS_UPDATE = 'TOKENS_UPDATE';
export const RESET_TOKEN = 'RESET_TOKEN';
export const USER_DETAILS = 'USER_DETAILS';
export const USER_LOGOUT = 'USER_LOGOUT';
export const LOAD_PERMISSIONS = 'LOAD_PERMISSIONS';
export const USER_PERMISSIONS = 'USER_PERMISSIONS';